import { Card } from "~/screens/Hub/Home/components";
import { ExpandableGrid } from "~/screens/Hub/Resources/components/ExpandableGrid";
import { Resource } from "~/shared.types";
import { customIcons } from "~/ui/common/Icons";

interface CommunitySectionProps {
  resources: Resource[];
}

export const CommunitySection = ({ resources }: CommunitySectionProps) => (
  <section>
    <ExpandableGrid
      title="Elektra Community"
      items={resources}
      renderCard={(item) => (
        <a href={item.link} target="_blank" rel="noopener noreferrer">
          <Card className="group flex h-full items-center rounded-lg hover:bg-neutral-100/50">
            <section className="flex h-full w-full items-center justify-start gap-2">
              <div className="bg-lightLavender group-hover:bg-lightLavender/50 rounded-full p-3 transition-colors duration-200">
                {item.content?.iconUrl ? (
                  <img
                    src={item.content.iconUrl}
                    alt={item.title}
                    className="size-7"
                  />
                ) : (
                  <customIcons.Conversation className="text-violet size-7" />
                )}
              </div>
              <h3 className="text-indigo font-semibold">{item.title}</h3>
            </section>
          </Card>
        </a>
      )}
    />
  </section>
);
